import { UseToastOptions, useToast as useChakraToast } from '@chakra-ui/react';
import { TOAST_MARGIN_LEFT } from 'constants/editor';

import { ToastContent } from './ToastLayout';

export const useToast = (options?: UseToastOptions) => {
  const toast = useChakraToast({
    position: 'bottom-left',
    containerStyle: { marginLeft: TOAST_MARGIN_LEFT },
    duration: 4000,
    isClosable: false,
    status: 'success',
    render: ({ title, description, status }) => {
      return <ToastContent title={title} description={description} status={status} />;
    },
    ...options,
  });

  return toast;
};
